import { TextInput } from "@inno-ui/text-input";
import { useTranslation } from "react-i18next";

import { useFieldContext } from "../../hooks/use-form";

type TextFieldProps = {
  placeholder: string;
  label: string;
};

export function TextInputField({ placeholder, label }: TextFieldProps) {
  const { t } = useTranslation();
  const field = useFieldContext<string>();

  return (
    <TextInput
      placeholder={placeholder}
      clearable={false}
      hasError={!!field.state.meta.errors[0]?.message}
      errorText={t(field.state.meta.errors[0]?.message)}
      label={label}
      name={field.name}
      value={field.state.value}
      onChange={e => field.handleChange(e.target.value)}
    />
  );
}
